module.exports = __webpack_public_path__ + "img/ic_safe.f9470025.png";